module.exports = __webpack_public_path__ + "img/Eritrea.f7e88955.gif";